import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: Number,
    url: String,
  }

  connect() {
    if (!this.urlValue) { return }

    const delay = this.delayValue || 0
    window.setTimeout(() => this.redirect(), delay)
  }

  redirect() {
    window.location = this.urlValue
  }
}
